import React, { useState } from 'react';
import './portal.css';
import Topo from '../../components/Topo';
import ContentSection from '../../components/ContentSection';
import transparencia from '../../imgs/Transparencia.jpg'; 
import transparencia2 from '../../imgs/Transparencia2.jpg';
import transparencia3 from  '../../imgs/transparencia3.jpg';
import transparencia4 from  '../../imgs/transparencia4.jpg';

const Portal = () => {
    const [selectedYear, setSelectedYear] = useState(''); 
    const [isImagesVisible, setImagesVisible] = useState(false);
    const [isTitleVisible, setTitleVisible] = useState(true); // Estado para controlar a visibilidade do título
    const [isTransitioning, setIsTransitioning] = useState(false); // Controla a transição

    const renderImagesByYear = () => {
        switch (selectedYear) {
            case '2024':
                return [transparencia, transparencia2]; 
            case '2025':
                return [transparencia3, transparencia4]; 
            case '2026':
                return []; 
            default:
                return []; 
        }
    };

    const handleYearClick = (year) => {
        if (selectedYear === year) {
            setImagesVisible(!isImagesVisible); 
        } else {
            setIsTransitioning(true); // Inicia a transição
            setTimeout(() => {
                setSelectedYear(year);
                setImagesVisible(true); 
                setIsTransitioning(false); // Finaliza a transição
            }, 500); // Duração da transição
        }
        setTitleVisible(false); // Esconder título "Portal da Transparência" ao clicar em um ano
    };

    return (
        <section id="portal" className="portal">
            <Topo page="Portal" />

            {/* Título "Portal da Transparência" */}
            <h1 className={`portal-title ${!isTitleVisible ? 'hidden' : ''}`}>
                PORTAL DA TRANSPARÊNCIA
            </h1>

            {/* Submenu para selecionar o ano */}
            <div className="submenu">
                <button 
                    className={selectedYear === '2024' ? 'active' : ''} 
                    onClick={() => handleYearClick('2024')}
                >
                    2024
                </button>
                <button 
                    className={selectedYear === '2025' ? 'active' : ''} 
                    onClick={() => handleYearClick('2025')}
                >
                    2025
                </button>
                <button 
                    className={selectedYear === '2026' ? 'active' : ''} 
                    onClick={() => handleYearClick('2026')}
                >
                    2026
                </button>
            </div>

            {/* Exibindo imagens de acordo com o ano selecionado */}
            {isImagesVisible && selectedYear && (
                <ContentSection 
                    title={`Relatórios do Ano ${selectedYear}`} 
                    imgs={renderImagesByYear()} 
                    className={`content-section ${!isTransitioning ? 'visible' : ''}`}
                >
                    <p className="pfirst">
                        Relatório de transparência correspondente ao ano de {selectedYear}.
                    </p>
                </ContentSection>
            )}
        </section>
    );
};

export default Portal;
